import i18n from "@/i18n";
import {useCookies} from "vue3-cookies";
import store from "@/store";
import {ElMessage, ElMessageBox} from 'element-plus'
import router from "@/router";

const {t} = i18n.global
const {cookies} = useCookies()
const messageDuration = 800

const unit = function () {
    return t('unit')
}

const shortcuts = [
    {
        text: '오늘',
        value: () => {
            const end = new Date()
            const start = new Date()
            return [start, end]
        },
    },
    {
        text: '어제',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
            return [start, end]
        },
    },
    {
        text: '이번달',
        value: () => {
            const date = new Date()

            const start = new Date(date.getFullYear(), date.getMonth(), 1)
            const end = new Date(date.getFullYear(), date.getMonth() + 1, 0)
            return [start, end]
        },
    },
    {
        text: '전월',
        value: () => {
            const date = new Date()

            const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
            const end = new Date(date.getFullYear(), date.getMonth(), 0)
            return [start, end]
        },
    },
    {
        text: '전전월',
        value: () => {
            const date = new Date()

            const start = new Date(date.getFullYear(), date.getMonth() - 2, 1)
            const end = new Date(date.getFullYear(), date.getMonth() - 1, 0)
            return [start, end]
        },
    },
    {
        text: '최근 1주일',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
        },
    },
    {
        text: '최근 30일',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
        },
    },
    {
        text: '최근 3개월',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (30 * 3 + 3))
            return [start, end]
        },
    },
    {
        text: '최근 6개월',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (30 * 6 + 6))
            return [start, end]
        },
    },
    {
        text: '최근 1년',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            return [start, end]
        },
    },
]

const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3,4})(\d{4})$/);
    if (match) {
        return match[1] + '-' + match[2] + '-' + match[3]
    }
    return null;
}

const yyyyMMdd = (str) => {
    const cleaned = ('' + str).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{4})(\d{2})(\d{2})$/);
    if (match) {
        return match[1] + '-' + match[2] + '-' + match[3]
    }
    return null;
}

const formatStoD = (s) => {
    const cleaned = ('' + s).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{4})(\d{2})(\d{2})$/);
    if (match) {
        return match[1] + '-' + match[2] + '-' + match[3]
    }
    return null;
}

const activeMenu = function (menu, lv1, lv2) {
    if (menu[lv1]) {
        menu[lv1].li.active = true;
        menu[lv1].a.active = true;

        if (menu[lv1][lv2]) {
            menu[lv1].div.show = true;
            menu[lv1].expend = true;
            menu[lv1][lv2].li.active = true;
            menu[lv1][lv2].a.active = true;
        }
    }
}

const getViewData = function (viewId) {
    return this.$store.getters['view/viewData'](viewId)
}

const setViewData = function (viewData) {
    store.dispatch('view/setViewData', viewData)
}

const setPreviousViewData = function (pageName, obj) {
    const viewData = {
        viewId: "prevPageData",
        viewData: {
            pageName: pageName,
            data: obj
        }
    }
    this.$setViewData(viewData)
}

const initDataByPreviousViewData = function (pageName, obj) {
    let changedData = false
    const prevViewData = this.$getViewData("prevPageData")
    const equalPreviousPage = prevViewData && prevViewData.pageName === pageName

    if (prevViewData && prevViewData.data && equalPreviousPage) {
        changedData = true
        Object.assign(obj, prevViewData.data)
    }

    this.$setViewData({
        viewId: "prevPageData",
        viewData: undefined
    })

    return changedData
}

const getCode = function (codeName, bAll) {
    const codes = store.getters['basic/codes']
    const rtn = [...codes[codeName]]; // deep copy
    if (bAll) {
        rtn.unshift({id: null, name: 'ALL', desc: '전체', desc2: '전체'})
    }
    return rtn;
}

const convertCode = function (codeName, id, type) {
    if (id == null) {
        return ""
    }

    const code = getCode(codeName)
    if (code === undefined) {
        return id
    }

    const f = code.find((o) => {
        if (o.id === id) {
            return true;
        }
    })

    if (f) {
        switch (type) {
            case 'id':
                return f.id
            case 'name':
                return f.name
            case 'desc2':
                return f.desc2
            default:
                return f.desc
        }
    } else {
        return id
    }
}

const setCodes = function () {
    const url = '/enums'
    return this.axios.get(url).then(res => {
        store.dispatch('basic/setCodes', res.data.response)
    }).catch(e => {
        console.log(e)
    });
}

// const setCompany = async function () {
//     const url = `/company`
//     const res = await this.axios.get(url, {
//         params: {
//             companyType: null,
//             approvalStatus: 'APPROVED',
//             size: 10000,
//             sort: 'COMPANY_NAME_ASC,COMPANY_POINT_NAME_ASC'
//         }
//     })
//
//     return store.dispatch('company/setAllCompany', res.data.response.content)
// }

const dateToString = function (date, addStr) {

    if (!date) {
        return null
    }

    const d = new Date(date)
    let month = '' + (d.getMonth() + 1)
    let day = '' + d.getDate()
    const year = d.getFullYear()

    if (month.length < 2) {
        month = '0' + month
    }
    if (day.length < 2) {
        day = '0' + day
    }

    if (addStr) {
        return [[year, month, day].join('-'), addStr].join(' ')
    }
    return [year, month, day].join('-')
}

const excelFileDownload = function (url, params, fileName) {
    this.axios.get(url, {
        params: params,
        responseType: 'blob'
    }).then(res => {
        console.log(res)
        const blob = new Blob([res.data], {type: res.headers['content-type']})
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    })
}

const existsObj = (obj) => {
    return Object.keys(obj).length
}

const isArray = (o) => {
    const type = typeof (o)
    if (type === 'object') {
        return Array.isArray(o)
    }
    return false
}

const initDateRange = (minDays) => {
    const startDate = new Date()
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * minDays)

    return [startDate, new Date()]
}

const isEmpty = (v) => {
    return v === undefined || v == null || v.trim() === ''
}

const nullOrEmptyToChar = (val, char = "-") => {
    return val == null || val.trim() === "" ? char : val
}

const datePickerShortcuts = [
    {
        text: 'LastWeek',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
        },
    },
    {
        text: 'LastMonth',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
        },
    },
    {
        text: 'Last3Month',
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
        },
    },
]

export default {
    install(app) {
        app.config.globalProperties.$getMessage = function (ctg, status, code) {
            const key = ctg + '.' + code

            if (t(key) === key) {
                return t(status)
            } else {
                return t(key)
            }
        }

        app.config.globalProperties.$getMsg = function (key) {

            if (t(key) === key) {
                return key
            } else {
                return t(key)
            }
        }

        // 로그인시 한번에 가져옴
        // app.config.globalProperties.$getMe = function (callback){
        //     return this.axios.get('/user/me')
        // }

        app.config.globalProperties.$logout = function (callback) {

            store.dispatch('basic/setAuth', {
                accessToken: '',
                expired: '',
                userRoles: []
            })
            store.dispatch('basic/initUser')

            this.$success("success.logout.normal")

            router.push({path: "/"})
        }

        app.config.globalProperties.$success = function (key) {
            return ElMessage({
                message: this.$getMsg(key),
                type: 'success',
                duration: messageDuration
            })
        }

        app.config.globalProperties.$info = function (key) {
            return ElMessage({
                message: this.$getMsg(key),
                type: 'info',
                duration: messageDuration
            })
        }

        app.config.globalProperties.$warning = function (key) {
            return ElMessage({
                message: this.$getMsg(key),
                type: 'warning',
                duration: messageDuration
            })
        }

        app.config.globalProperties.$error = function (key) {
            return ElMessage({
                message: this.$getMsg(key),
                type: 'error',
                duration: messageDuration
            })
        }

        app.config.globalProperties.$resizePopup = function (width, height) {
            if (height) {
                window.resizeTo(width, height);
            } else {
                window.resizeTo(width,
                    document.body.scrollHeight + (window.outerHeight
                        - window.innerHeight));
            }
        }

        app.config.globalProperties.$print = function (data) {
            for (const i in data) {
                console.log(i, data[i])
            }
        }

        app.config.globalProperties.$numFormat = function (str) {
            str = String(str);
            return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
        }

        app.config.globalProperties.$unit = unit;
        app.config.globalProperties.$activeMenu = activeMenu;
        app.config.globalProperties.$setViewData = setViewData;
        app.config.globalProperties.$getViewData = getViewData;
        app.config.globalProperties.$initDataByPreviousViewData = initDataByPreviousViewData;
        app.config.globalProperties.$setPreviousViewData = setPreviousViewData;
        app.config.globalProperties.$getCode = getCode;
        app.config.globalProperties.$setCodes = setCodes;
        // app.config.globalProperties.$setCompany = setCompany;
        app.config.globalProperties.$dateToString = dateToString;
        app.config.globalProperties.$convertCode = convertCode;
        app.config.globalProperties.$excelFileDownload = excelFileDownload;
        app.config.globalProperties.$formatPhoneNumber = formatPhoneNumber;
        app.config.globalProperties.$yyyyMMdd = yyyyMMdd;
        app.config.globalProperties.$formatStoD = formatStoD;
        app.config.globalProperties.$existsObj = existsObj;
        app.config.globalProperties.$isArray = isArray;
        app.config.globalProperties.$nullOrEmptyToChar = nullOrEmptyToChar;
        app.config.globalProperties.$datePickerShortcuts = datePickerShortcuts;

        app.config.globalProperties.$alertMsg = function (title, m) {

            return ElMessageBox.alert(
                this.$getMsg(m),
                title,
                {
                    confirmButtonText: this.$getMsg('btn.ok'),
                    dangerouslyUseHTMLString: true,
                }
            )
        }

        app.config.globalProperties.$confirmMsg = function (title, m, type) {

            return ElMessageBox.confirm(
                this.$getMsg(m),
                this.$getMsg(title),
                {
                    confirmButtonText: this.$getMsg('btn.ok'),
                    cancelButtonText: this.$getMsg('btn.cancel'),
                    type: type,
                    dangerouslyUseHTMLString: true,
                }
            )
        }

        app.config.globalProperties.$promptMsg = function (title, m, btnOkKey,
            btnCancelKey, pattern, e) {

            return ElMessageBox.prompt(this.$getMsg(m), this.$getMsg(title), {
                confirmButtonText: this.$getMsg(btnOkKey),
                cancelButtonText: this.$getMsg(btnCancelKey),
                inputPattern: pattern,
                inputErrorMessage: this.$getMsg(e),
                dangerouslyUseHTMLString: true,
            })

        }

        app.config.globalProperties.$getAllApps = function () {
            const url = `/apps`
            return this.axios.get(url, {
                params: {
                    limit: 100000
                }
            })
        }

        app.config.globalProperties.$initDateRange = initDateRange
        app.config.globalProperties.$compareObj = (obj1, obj2) => {
            if (existsObj(obj1) !== existsObj(obj2)) {
                return false
            }

            for (const i in obj1) {
                if (String(obj1[i]) !== String(obj2[i])) {
                    return false
                }
            }

            return true
        }

        app.config.globalProperties.$fileUpload = function (uploadFile) {
            const formData = new FormData()
            formData.append('uploadFile', uploadFile)
            return this.axios.post('/files/uploadImage', formData,
                {headers: {'Content-Type': 'multipart/form-data'}}
            )
        }

        app.config.globalProperties.$isEmpty = isEmpty

        app.config.globalProperties.$checkSize = function (width, height,
            widthRatio, heightRatio) {
            let w = width / width
            let h = height / width

            const magnification = widthRatio
            w = Math.round(w * magnification * 10) / 10
            h = Math.round(h * magnification * 10) / 10

            if (w !== widthRatio || h !== heightRatio) {
                alert(
                    `이미지의 비율(가로:세로)이 맞지 않습니다. (권장 ${widthRatio}:${heightRatio},  실제 ${w}:${h})`)
                return false
            }

            return true
        }

        app.config.globalProperties.$generateRandomString = function (len) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            let result = '';
            const charactersLength = characters.length;
            for (let i = 0; i < len; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength));
            }

            return result;
        }

        app.config.globalProperties.$shortcuts = shortcuts
    }
}
